import React from "react";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const NotFound = () => (
    <Paper className="common-paper">
        <Typography variant="h4">404! Страница не найдена </Typography>
    </Paper>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js